module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (14).4cae344f.jpg";